(function () {
  'use strict';

  if (window.HalalCartController) return;

  var BUTTON_SELECTOR = [
    '.modern-atc-button',
    '.fresh-product-card__button',
    '[class*="ai-featured-products-card-add-btn-"]',
    'button[data-btn-addToCart]',
    'input[data-btn-addToCart]'
  ].join(',');
  var buttonState = new WeakMap();
  var toastTimer = 0;
  var cartSyncId = 0;
  var drawerSyncId = 0;

  function isCompactButton(button) {
    return button.matches('.modern-atc-button, .fresh-product-card__button, [class*="ai-featured-products-card-add-btn-"]');
  }

  function ensureStyles() {
    if (document.getElementById('halal-cart-controller-styles')) return;
    var style = document.createElement('style');
    style.id = 'halal-cart-controller-styles';
    style.textContent =
      '.halal-cart-is-loading{cursor:wait!important;pointer-events:none!important;opacity:.82!important}' +
      '.halal-cart-is-added{background-color:#2c8f3f!important;color:#fff!important}' +
      '.halal-cart-compact-state{display:inline-flex;align-items:center;justify-content:center;width:24px;height:24px;color:#fff!important;font-size:24px;font-weight:700;line-height:1}' +
      '.modern-atc-button.halal-cart-is-loading,.modern-atc-button.halal-cart-is-added,' +
      '.fresh-product-card__button.halal-cart-is-loading,.fresh-product-card__button.halal-cart-is-added,' +
      '[class*="ai-featured-products-card-add-btn-"].halal-cart-is-loading,' +
      '[class*="ai-featured-products-card-add-btn-"].halal-cart-is-added{color:#fff!important}';
    document.head.appendChild(style);
  }

  function showToast(message, isError) {
    var toast = document.getElementById('halal-cart-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.id = 'halal-cart-toast';
      toast.className = 'halal-cart-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    window.clearTimeout(toastTimer);
    toast.textContent = message;
    toast.classList.toggle('is-error', !!isError);
    toast.classList.add('is-visible');
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function begin(button) {
    if (!button || button.disabled || buttonState.has(button)) return false;

    buttonState.set(button, {
      html: button.innerHTML,
      value: button.value,
      disabled: button.disabled
    });

    button.disabled = true;
    button.dataset.halalCartPending = 'true';
    button.setAttribute('aria-busy', 'true');
    button.classList.remove('halal-cart-is-added', 'is-success', 'added');
    button.classList.add('halal-cart-is-loading');

    if (button.tagName === 'INPUT') {
      button.value = 'Adding…';
    } else if (isCompactButton(button)) {
      button.innerHTML = '<span class="halal-cart-compact-state" aria-hidden="true">•••</span>';
    } else {
      button.textContent = 'Adding…';
    }

    return true;
  }

  function restore(button) {
    var state = buttonState.get(button);
    if (!state) return;

    button.classList.remove('halal-cart-is-loading', 'halal-cart-is-added', 'loading', 'is-loading', 'is-success', 'added');
    button.removeAttribute('aria-busy');
    button.dataset.halalCartPending = 'false';
    button.disabled = state.disabled;

    if (button.tagName === 'INPUT') button.value = state.value;
    else button.innerHTML = state.html;

    buttonState.delete(button);
  }

  function succeed(button, item) {
    button.classList.remove('halal-cart-is-loading');
    button.classList.add('halal-cart-is-added');

    if (button.tagName === 'INPUT') {
      button.value = 'Added ✓';
    } else if (isCompactButton(button)) {
      button.innerHTML = '<span class="halal-cart-compact-state" aria-hidden="true">✓</span>';
    } else {
      button.textContent = 'Added ✓';
    }

    var title = item && (item.product_title || item.title);
    showToast(title ? title + ' added to cart' : 'Added to cart', false);
    window.setTimeout(function () { restore(button); }, 650);
  }

  function fail(button, message) {
    restore(button);
    showToast(message || 'Could not add product. Please try again.', true);
  }

  function updateCartIndicators(cart) {
    var count = Number(cart && cart.item_count) || 0;
    var countText = String(count);

    document.querySelectorAll('[data-cart-count], .cartCount').forEach(function (element) {
      element.textContent = countText;
    });

    document.querySelectorAll('[data-cart-text]').forEach(function (element) {
      element.textContent = count === 1 ? 'item' : 'items';
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
      bubble.classList.toggle('is-empty', count === 0);
      var accessibleCount = bubble.querySelector('.visually-hidden');
      if (accessibleCount) accessibleCount.textContent = countText + (count === 1 ? ' item' : ' items');
    });
  }

  function syncCart() {
    var requestId = ++cartSyncId;
    var url = (window.routes && window.routes.cart) || '/cart.js';

    return fetch(url, {
      method: 'GET',
      headers: { Accept: 'application/json' },
      cache: 'no-store'
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh cart');
      return response.json();
    })
    .then(function (cart) {
      if (requestId === cartSyncId) updateCartIndicators(cart);
      document.dispatchEvent(new CustomEvent('halalcart:updated', { detail: { cart: cart } }));
      return cart;
    })
    .catch(function (error) {
      console.error('Halal Cart: cart sync failed', error);
      return null;
    });
  }

  function activateInlineScripts(scope) {
    scope.querySelectorAll('script').forEach(function (oldScript) {
      var newScript = document.createElement('script');
      Array.prototype.forEach.call(oldScript.attributes, function (attribute) {
        newScript.setAttribute(attribute.name, attribute.value);
      });
      newScript.textContent = oldScript.textContent;
      oldScript.replaceWith(newScript);
    });
  }

  function refreshNativeDrawer() {
    var wrapper = document.querySelector('#halo-cart-sidebar .previewCart-wrapper');
    if (!wrapper) return Promise.resolve(null);

    var requestId = ++drawerSyncId;
    var cartPath = (window.routes && window.routes.cart) || '/cart';
    cartPath = cartPath.split('?')[0].replace(/\.js$/, '');
    var url = cartPath + '?view=ajax_side_cart&_=' + Date.now();

    wrapper.setAttribute('aria-busy', 'true');

    return fetch(url, {
      method: 'GET',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      },
      cache: 'no-store'
    })
    .then(function (response) {
      if (!response.ok) throw new Error('Unable to refresh cart drawer');
      return response.text();
    })
    .then(function (html) {
      if (requestId !== drawerSyncId) return null;

      wrapper.innerHTML = html;
      activateInlineScripts(wrapper);
      return html;
    })
    .catch(function (error) {
      console.error('Halal Cart: drawer sync failed', error);
      return null;
    })
    .finally(function () {
      if (requestId === drawerSyncId) wrapper.removeAttribute('aria-busy');
    });
  }

  function requestBody(button, form) {
    if (form) return { body: new FormData(form), headers: { Accept: 'application/json' } };

    var variantId = button.dataset.variantId || button.dataset.productId;
    if (!variantId) return null;

    return {
      body: JSON.stringify({ id: variantId, quantity: 1 }),
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' }
    };
  }

  function add(button, form) {
    if (!begin(button)) return;

    var request = requestBody(button, form);
    if (!request) {
      fail(button, 'Please select a product option first.');
      return;
    }

    var controller = typeof AbortController === 'function' ? new AbortController() : null;
    var timeout = window.setTimeout(function () {
      if (controller) controller.abort();
    }, 10000);
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add.js';
    var options = {
      method: 'POST',
      headers: request.headers,
      body: request.body
    };
    if (controller) options.signal = controller.signal;

    fetch(url, options)
      .then(function (response) {
        return response.json().catch(function () { return {}; }).then(function (data) {
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'Could not add product. Please try again.');
          }
          return data;
        });
      })
      .then(function (item) {
        succeed(button, item);
        syncCart();
        refreshNativeDrawer();
      })
      .catch(function (error) {
        var message = error && error.name === 'AbortError'
          ? 'The cart took too long to respond. Please try again.'
          : (error && error.message);
        fail(button, message);
      })
      .finally(function () {
        window.clearTimeout(timeout);
      });
  }

  function addFormFor(button) {
    var form = button && button.closest('form');
    if (!form) return null;
    var action = form.getAttribute('action') || '';
    return /\/cart\/add(?:\.js)?(?:\?|$)/.test(action) || button.closest('product-form') ? form : null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest && event.target.closest(BUTTON_SELECTOR);
    if (!button || !/^(BUTTON|INPUT)$/.test(button.tagName) || button.classList.contains('sold-out')) return;

    var form = addFormFor(button);
    var hasVariant = button.dataset.variantId || button.dataset.productId;
    if (!form && !hasVariant) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    add(button, form);
  }, true);

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    var action = form.getAttribute('action') || '';
    if (!/\/cart\/add(?:\.js)?(?:\?|$)/.test(action) && !form.closest('product-form')) return;

    var button = form.querySelector('[data-btn-addToCart], [name="add"][type="submit"], button[type="submit"][name="add"]');
    if (!button) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    add(button, form);
  }, true);

  ensureStyles();
  window.HalalCartController = {
    add: add,
    refresh: syncCart,
    refreshDrawer: refreshNativeDrawer,
    toast: showToast
  };
})();
/* Halal Cart recovery save: 20260811-reapply-2 */
